import { Injectable, Output, EventEmitter } from '@angular/core';

export interface BreadcrumStep {
    text: string,
    isLastStep: boolean
}

export interface BreadcrumLocation {
    currentLocation: Array<BreadcrumStep>,
    backButtonVisible: boolean,
    backButtonLocation: string
}

@Injectable()
export class BreadcrumService {
    @Output() currentLocationChanged: EventEmitter<BreadcrumLocation> = new EventEmitter<BreadcrumLocation>();

    currentLocation: Array<BreadcrumStep>;

    setCurrentLocation(currentLocation: Array<BreadcrumStep>, backButtonVisible: boolean, backButtonLocation: string) {
        this.currentLocation = currentLocation;

        this.currentLocationChanged.emit({
            backButtonLocation: backButtonLocation,
            backButtonVisible: backButtonVisible,
            currentLocation: currentLocation
        });
    }

    setLastStepDescription(description: string) {
        if (this.currentLocation) {
            this.currentLocation.forEach(item => {
                if (item.isLastStep) {
                    item.text = description;
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/services/breadcrum.service.ts